import React from 'react';
import { Helmet } from 'react-helmet-async'; // Import Helmet
import './AboutPage.css'; // Add a CSS file for styling

// Placeholder for founder image - replace with actual path
import founderImage from '../assets/adam-wagenfield.png'; // Example path

const AboutPage: React.FC = () => {
  return (
    // Use a more specific class like 'about-page' instead of 'contact-page'
    <div className="about-page">
      <Helmet>
        <title>About IntelPro | Company Philosophy & Team</title>
        <meta name="description" content="Learn about IntelPro's philosophy of understanding, solving, and innovating in business improvement, and meet the founder, Adam W." />
      </Helmet>
      <div className="container">
        <h1 className="welcome-heading">About IntelPro</h1>

        {/* --- Company Philosophy Section --- */}
        <section className="about-section company-philosophy">
          <h2>Our Philosophy: Understand, Solve, Innovate</h2>
          <p>
            At IntelPro, we're driven by a fundamental curiosity to understand how things work. We believe that truly effective solutions stem from a deep dive into the intricacies of your business processes. We don't just look at the surface; we analyse workflows, identify bottlenecks, and uncover hidden inefficiencies.
          </p>
          <p>
            Our core strength lies in <strong>problem-solving</strong>. We thrive on complexity and enjoy the challenge of transforming operational hurdles into opportunities for growth. We combine analytical rigor with practical experience to devise strategies that are not only insightful but also actionable.
          </p>
          <p>
            Beyond just fixing problems, we are committed to <strong>innovation</strong>. We constantly explore new technologies and methodologies to bring fresh perspectives and cutting-edge solutions to our clients, ensuring they stay ahead in an ever-evolving landscape. Whether it's through process automation, custom reporting, or bespoke application development, our goal is to deliver tangible, lasting improvements.
          </p>
        </section>

        {/* --- Founder Section --- */}
        <section className="about-section founder-profile">
          <h2>Meet The Founder</h2>
          <div className="founder-content">
            <img src={founderImage} alt="Adam W." className="founder-image" />
            <div className="founder-text">
              <h3>Adam W.</h3>
              <p>
                Adam brings over a decade of cross-sector experience in driving business improvement and operational excellence. With a strong background in process analysis, project management (APM certified), and data-driven decision-making, he has successfully supported major UK organisations in sectors including energy, telecoms, and retail.
              </p>
              <p>
                His expertise lies in bridging the gap between business needs and technical solutions, focusing on practical implementation and sustainable change. Adam is passionate about leveraging technology like Power BI, SQL, and low-code platforms to create efficient workflows and insightful reporting, ultimately helping businesses cut through complexity and deliver results.
              </p>
              {/* Optional: Link to LinkedIn */}
              <a href="https://www.linkedin.com/in/awagenfield/" target="_blank" rel="noopener noreferrer" className="linkedin-link">
                View LinkedIn Profile
              </a>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default AboutPage;